import Vue from 'vue'
import App from './App'
import router from './router'
import store from   './store/store'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'animate.css'
//import styles
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import "./lib/globalFunctions";
import "./lib/georgianToJalali";
import "./lib/socket"
import './store/store'
import "./lib/state";
import "./lib/axios";
import VueCookies from "vue-cookies";
import "sweetalert2/dist/sweetalert2.min.css";
import "./styles/SweetAlertStyle.scss";
import VueSweetalert2 from "vue-sweetalert2";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import  './styles/style.css'
import './lib/globalConstants'
import LabelInput from "./views/tools/LabelInput";
//import state
import './lib/state'
Vue.config.productionTip = false
//vue carousel
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
//import trend chart
import TrendChart from "vue-trend-chart";
Vue.use(TrendChart);

Vue.use(require('moment'));


//import apexchart
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('LabelInput',LabelInput)

Vue.component('apex-chart', VueApexCharts)
Vue.use(VueCookies);
Vue.use(VueSweetalert2);
Vue.component("date-picker", VuePersianDatetimePicker);
Vue.use(PerfectScrollbar,{
  options:{
    // swipeEasing: false,
    wheelPropagation: false,
  }
})
//import InlineSvg
import InlineSvg from 'vue-inline-svg';
Vue.component('inline-svg', InlineSvg);








new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
